import React, {PureComponent} from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal,
} from 'reactstrap';
import TrendingDownIcon from 'mdi-react/TrendingDownIcon';
import axios from "axios";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

var url = window.location.hostname;
var port = window.location.port;

class ShelfLifeDetail extends PureComponent{
  
  state = {
    dataset : []
  }
  
  
  DetailSummary = () => {
    const payload = {
      "location": this.getCookie('selectedLocation'),
        "report_type": "ShelfLife",
        "report_detailed" : ""
    };
    
    API.post('/reports/dashboardStaticCount/v1/', { param: payload })
    // axios('http://'+url+'/reports/dashboardStaticCount/v1/',
    // {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //   },
    //   data:{
    //     "location": this.getCookie('selectedLocation'),
    //     "report_type": "ShelfLife",
    //     "report_detailed" : ""
    //   }
    // })
    .then((response) => {
		this.setState({
		dataset:response.data.data
		})
		
    })
  }
  
  
   getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }
  
  
  
  componentDidMount(){
    if (port == 8091 || port === ":8090") {
      port = ":8090"
    }else{
      port = ":8088"
    }
	 if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }
	  
    this.DetailSummary();
  }
  
  
render(){
	
	 const ShelfLifeData = {

      columns: [

       
        {

          label:'Zone',
		  field:'Zone'

        },


        {

          label:'BinID',
		  field:'BinID'

        },

        

        {

          label:'LBSKUID',
		  field:'LBSKUID'

        },

        {

          label:'Description',
          field:'Description',


        },

        {

          label:'BasepackCode',
          field:'BasepackCode',

        },

        {

          label:'CBUCode',
		  field:'CBUCode'

        },
		
		{

          label:'PKD',
		  field:'PKD'

        },

        {

          label:'MonthsToExpiry',
          field:'MonthsToExpiry',


        },

        {

          label:'BinQty',
          field:'BinQty',

        },

        {

          label:'ShelfLife',
		  field:'ShelfLife'

        },


        
      ],

      rows:this.state.dataset,

    }




    return (
	
	<Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Shelf Life</h3>
      </Col>
    </Row>
   
    <Row>
      <Col xl={12}>
    <Card>
	<CardBody>
	<div className="table_val">
            <MDBDataTable
                striped
                bordered
                hover
                data={ShelfLifeData}
                sorting={true}
                paging = {true}
              />
            </div>
	</CardBody>
	</Card>
	</Col>
    </Row>

    
  </Container>
	
  );
  }
}

export default ShelfLifeDetail;
